/* eslint-disable prefer-template */
import React, { useState } from 'react';
import '../style.css';
import { useIntl } from 'react-intl';
import { TextField } from '@material-ui/core';
import RegistrationStatus from './registrationStatus';
import GradientButton from '../../customMui/newButton/newButton';
export default function WithOutRegistration({
	handleChange,
	hanleContinue,
	// userDetails,
	errorObj,
	registrationStatus,
	webinarData
})
{
	const intl = useIntl();
	// const [ localErrorObj, setLocalErrorObj ] = useState({});
	// const [ isButtonDisabled, setIsButtonDisabled ] = useState(false);

	// Function to validate email domain
	// const validateEmailDomain = (email) =>
	// 	{
	// 		// If no email, return early
	// 		if (!email) return true;

	// 		// Extract domain from email
	// 		const domain = email.split('@')[1];

	// 		// Check authorized domains
	// 		if (webinarData?.authorizedDomains?.length > 0)
	// 		{
	// 			const isAuthorizedDomain = webinarData.authorizedDomains.some(
	// 				(authDomain) => domain === authDomain
	// 			);

	// 			if (!isAuthorizedDomain)
	// 			{
	// 				setLocalErrorObj((prev) => ({
	// 					...prev,
	// 					emailDomainErr : intl.formatMessage(
	// 						{ id: 'email.unauthorized_domain', defaultMessage: 'This email domain is not authorized.' }
	// 					)
	// 				}));
	// 				setIsButtonDisabled(true);

	// 				return true;
	// 			}
	// 		}

	// 		// Check restricted domains
	// 		if (webinarData?.restrictedDomains?.length > 0)
	// 		{
	// 			const isRestrictedDomain = webinarData.restrictedDomains.some(
	// 				(restrictedDomain) => domain === restrictedDomain
	// 			);

	// 			if (isRestrictedDomain)
	// 			{
	// 				setLocalErrorObj((prev) => ({
	// 					...prev,
	// 					emailDomainErr : intl.formatMessage(
	// 						{ id: 'email.restricted_domain', defaultMessage: 'This email domain is not allowed.' }
	// 					)
	// 				}));
	// 				setIsButtonDisabled(true);

	// 				return true;
	// 			}
	// 		}

	// 		// Clear domain-related errors if validation passes
	// 		const { emailDomainErr, ...restErrors } = localErrorObj;

	// 		setLocalErrorObj(restErrors);
	// 		setIsButtonDisabled(false);

	// 		return true;
	// 	};

	// Enhanced handleChange to include domain validation
	const modifiedHandleChange = (e) =>
	{
		// Call the original handleChange first
		// if(localErrorObj?.emailDomainErr){
		// 	setLocalErrorObj({});
		// 	setIsButtonDisabled(false);
		// }
		handleChange(e);

		// If the field is email, perform domain validation
		// if (e.target.id === 'Email')
		// {
		// 	validateEmailDomain(e.target.value);
		// }
	};

	// console.log('localErrorObj', localErrorObj);

	return (
		<>
			{registrationStatus ? (
				<RegistrationStatus status={registrationStatus}/>
			) : (
				<div className='flexCol'>
					<span className='mHdng'>
						{intl.formatMessage({ id: 'Enter_Your_Details', defaultMessage: 'Enter Your Details' })}
					</span>
					<div className='flexCol pdngVSM fieldCntnr'>
						{webinarData?.registrationFields?.map((each, index) => (
							<div className='flexCol pdngVSM' key={index}>
								<TextField
									fullWidth
									id={each?.field}
									label={each?.field}
									variant='standard'
									size='small'
									className='streamFields'
									onChange={modifiedHandleChange}
								/>
								{/* {
									Object.keys(localErrorObj || {}).length > 0 && each?.field === 'Email' &&
										<small className='small pdngTXXS errTxt'>{localErrorObj?.emailDomainErr}</small>
								} */}
								{
									Object.keys(errorObj).length > 0 &&
									<small className='small pdngTXXS errTxt'>{errorObj[each?.field + '_err']}</small>
								}
							</div>
						))}
					</div>
					<div className='flexCol jCntr pdngVMD w50'>
						<GradientButton
							onClick={() => hanleContinue()}
							variant='contained'
							color='primary'
							id='joinButton'
							// disabled={isButtonDisabled}
							disableElevation
						>
							{intl.formatMessage({ id: 'webinar.joinWebinar', defaultMessage: 'Join Webinar' })}
						</GradientButton>
					</div>
				</div>
			)}
		</>
	);
}